import { Colors } from '../lib/util';
import './Balls.css';

export default function Balls({ color }: { color?: Colors }): JSX.Element {
  return (
    <div className={`vipps-loader ${color || Colors.Orange}`} role="status" aria-label="Loading">
      <div className="vipps-ball"></div>
      <div className="vipps-ball"></div>
      <div className="vipps-ball"></div>
    </div>
  );
}
